import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const CompanyForm = ({ company, onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    sector: '',
    contactEmail: '',
    contactPhone: '',
    address: ''
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (company) {
      setFormData({
        name: company?.name || '',
        sector: company?.sector || '',
        contactEmail: company?.contactEmail || '',
        contactPhone: company?.contactPhone || '',
        address: company?.address || ''
      });
    }
  }, [company]);

  const sectorOptions = [
    { value: 'Manufacturing', label: 'Manufacturing' },
    { value: 'Energy', label: 'Energy' },
    { value: 'Automotive', label: 'Automotive' },
    { value: 'Pharmaceutical', label: 'Pharmaceutical' },
    { value: 'Food & Beverage', label: 'Food & Beverage' },
    { value: 'Chemical', label: 'Chemical' },
    { value: 'Technology', label: 'Technology' },
    { value: 'Other', label: 'Other' }
  ];

  const validateForm = () => {
    const newErrors = {};
    if (!formData?.name?.trim()) newErrors.name = 'Company name is required';
    if (!formData?.sector) newErrors.sector = 'Sector is required';
    if (formData?.contactEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(formData?.contactEmail)) {
      newErrors.contactEmail = 'Invalid email format';
    }
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (validateForm()) {
      onSubmit(formData);
    }
  };

  return (
    <div className="fixed inset-0 z-modal flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm animate-in">
      <div className="bg-card rounded-xl border border-border shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
              <Icon name="Building2" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-foreground">
                {company ? 'Edit Company' : 'Create New Company'}
              </h2>
              <p className="text-sm text-muted-foreground">Enter company details</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-lg hover:bg-muted transition-colors duration-250 flex items-center justify-center"
            aria-label="Close modal"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <Input
            label="Company Name"
            type="text"
            placeholder="Enter company name"
            required
            value={formData?.name}
            onChange={(e) => setFormData({ ...formData, name: e?.target?.value })}
            error={errors?.name}
          />

          <Select
            label="Industry Sector"
            options={sectorOptions}
            value={formData?.sector}
            onChange={(value) => setFormData({ ...formData, sector: value })}
            placeholder="Select sector"
            required
            error={errors?.sector}
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Contact Email"
              type="email"
              placeholder="contact@company.com"
              value={formData?.contactEmail}
              onChange={(e) => setFormData({ ...formData, contactEmail: e?.target?.value })}
              error={errors?.contactEmail}
            />

            <Input
              label="Contact Phone"
              type="tel"
              placeholder="+1 (555) 000-0000"
              value={formData?.contactPhone}
              onChange={(e) => setFormData({ ...formData, contactPhone: e?.target?.value })}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Address
            </label>
            <textarea
              className="w-full h-24 px-4 py-3 rounded-xl border border-input bg-background text-foreground resize-none focus:outline-none focus:ring-2 focus:ring-ring transition-colors duration-250"
              placeholder="Enter company address"
              value={formData?.address}
              onChange={(e) => setFormData({ ...formData, address: e?.target?.value })}
            />
          </div>

          <div className="flex items-center gap-3 pt-4 border-t border-border">
            <Button type="button" variant="outline" fullWidth onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" variant="default" fullWidth iconName="Save">
              {company ? 'Update Company' : 'Create Company'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompanyForm;